// extracted by mini-css-extract-plugin
module.exports = {"core":"Logo-core-3sWlu","link":"Logo-link-3Cxxy"};